import React from 'react';

export default function ({ highlightsfeed, eleRef }) {
    return (
        <section className="main_container_block_feeds">
                          <div className="main_block_container_feed">
                               <div className="block_container_feed_heading_text baby_name_header R15_61">
                                  {highlightsfeed.title ? highlightsfeed.title : ''}
                                </div>
                                <div className="main_container_block_feeds_main">
                                <div className="content-div_view_artical">
                                    <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Baby_Names_Banner.png" alt="logo"/>
                                </div>
                                 <div className="baby_names-section">
                                    <div className="baby_names-tools-names">
                                      
                                    {highlightsfeed.data && highlightsfeed.data.map((highlightsfeed, index) =>
                                    <div>
                                       {highlightsfeed.gender == "Girl" &&
                                       <div className="names_babys">
                                          <span className="icons_baby"> <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/female.svg" alt="logo"/> </span>
                                          <span className="R15_21">{highlightsfeed.babyname? highlightsfeed.babyname : ''}</span>
                                       </div>
                                        }
                                        {highlightsfeed.gender == "Boy" &&
                                       <div className="names_babys">
                                          <span className="icons_baby"> 
                                          <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/male.svg" alt="logo"/> </span>
                                          <span className="R15_21">{highlightsfeed.babyname?highlightsfeed.babyname:''}</span>
                                       </div>
                                        }
                                        </div>
                                    )}


                                        
                                    </div>
                                    <div className="explore_baby_names">
                                        <a href='https://parenting.firstcry.com/baby-names/'>
                                         <button className="M16_42 gtm-babyname" type="button" >Explore Baby Name <span data-icon-font="h" className="icon"></span> </button>
                                         </a>
                                    </div>
                                 </div>
                                </div> 
                            </div>
                        </section>
    )
}
